module.exports = __webpack_public_path__ + "static/media/Google_Maps_icon.b0a38214.png";